<div id="historyContainer" class="flex-col">
    <div id="history" class="flex-col">
        @for ( comment of commentsInternal() | slice : 0 : commentsShown(); track comment.idContenuto; let index = $index; let isLast = $last ) {
        <dottnet-comment-bubble [id]="'comment-' + comment.idContenuto" [comment]="comment" [repliesSignal]="getRepliesSignalForId(comment.idContenuto)" [indentLevel]="indentLevel" [areActionsEnabled]="isLast && areThereMoreComments() ? false : true" [ngClass]="{ 'last-comment-fade': isLast && areThereMoreComments() }"
            [ngStyle]="{
            'padding-left': indentLevel === 0 ? 0 : 1 + 'rem'
          }" (showReplyBoxEmitter)="showReplyBox($event)" [replyBus]="replyBus()" [submitCommentBus]="submitCommentBus()" (submitCommentEmitter)="emitSubmitComment($event)">
        </dottnet-comment-bubble>
        }
    </div>

    @if (commentsInternal()?.length > commentsShown()) {
    <div class="history-toolbar flex-row flex-justify-center flex-align-center">
        @if (indentLevel
        < 1) { <button mat-stroked-button class="flex-row flex-justify-center" color="accent" (click)="showMoreComments()">
            {{ showMoreLabel }}
            </button>
            } @if (indentLevel >= 1) {
            <a mat-icon-button class="flex-row flex-justify-center" (click)="showMoreComments()">
        {{ showMoreLabel }}
      </a> }
    </div>
    }
</div>
